const Main = () => import ('../views/main/main.vue')
const psuBzjReturnIndex = () => import ('@/views/cwgl/psuBzjReturnIndex')
const psuBzjReturnForm = () => import ('@/views/cwgl/psuBzjReturnForm')
const psuFwfconIndex = () => import ('@/views/cwgl/psuFwfconIndex')
const psuFwfconForm = () => import ('@/views/cwgl/psuFwfconForm')
const psuBmfAffirmIndex = () => import ('@/views/cwgl/psuBmfAffirmIndex')
const psuBmfAffirmForm = () => import ('@/views/cwgl/psuBmfAffirmForm')
const psuBzjAffirmIndex = () => import ('@/views/cwgl/psuBzjAffirmIndex')
const psuBzjAffirmForm = () => import ('@/views/cwgl/psuBzjAffirmForm')
export default [{
  path: '/cwgl',
  component: Main,
  redirect: '',
  meta: {
    title: '财务管理',
    icon: 'guide'
  },
  children: [
    {
      path: 'psuBzjReturnIndex',
      component: psuBzjReturnIndex,
      name: 'psuBzjReturnIndex',
      meta: { title: '保证金退回', keepAlive: true }
    },
    {
      path: 'psuBzjReturnForm',
      component: psuBzjReturnForm,
      name: 'psuBzjReturnForm',
      meta: { title: '保证金退回详情', keepAlive: true }
    },
    {
      path: 'psuFwfconIndex',
      component: psuFwfconIndex,
      name: 'psuFwfconIndex',
      meta: { title: '服务费', keepAlive: true }
    },
    {
      path: 'psuFwfconForm',
      component: psuFwfconForm,
      name: 'psuFwfconForm',
      meta: { title: '服务费确认', keepAlive: true }
    },
    {
      path: 'psuBmfAffirmIndex',
      component: psuBmfAffirmIndex,
      name: 'psuBmfAffirmIndex',
      meta: { title: '报名费', keepAlive: true }
    },
    {
      path: 'psuBmfAffirmForm',
      component: psuBmfAffirmForm,
      name: 'psuBmfAffirmForm',
      meta: { title: '报名费确认', keepAlive: true }
    },
    {
      path: 'psuBzjAffirmIndex',
      component: psuBzjAffirmIndex,
      name: 'psuBzjAffirmIndex',
      meta: { title: '保证金', keepAlive: true }
    },
    {
      path: 'psuBzjAffirmForm',
      component: psuBzjAffirmForm,
      name: 'psuBzjAffirmForm',
      meta: { title: '保证金确认', keepAlive: true }
    }
  ]
}]
